import React from "react";
import { Badge } from "reactstrap";

export default function paymentTypeBadge(type, check_number) {
    if (!type) return <Badge color="secondary">-</Badge>;

    const t = type.toLowerCase();
    let label = type;
    let style = {};
    let color = "secondary";

    if (t.startsWith("stripe")) {
        label = "Stripe " + (type.split("_")[1]?.replace(/_/g, " ") || "").trim();
        style = {
            background: "linear-gradient(90deg, #6772E5 0%, #5469D4 100%)",
            color: "#fff",
            border: "none",
        };
    } else if (t.startsWith("cod") || t.startsWith("cash")) {
        color = "success";
        label = "Cash";
    } else if (t.startsWith("cheque")) {
        color = "info";
        label = "Check" + (check_number != null ? ` (#${check_number})` : "");
    } else if (t.startsWith("qbo")) {
        color = "warning";
        label = "QBO";
    }

    return (
        <Badge color={color} style={style}>
            {label || "-"}
        </Badge>
    );
}